import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider, createRouter } from "@tanstack/react-router";

import { CommandPaletteProvider } from "@/providers/CommandPaletteProvider";
import { DemoModeProvider } from "@/providers/DemoModeProvider";
import { QueryProvider } from "@/providers/QueryProvider";
import { ThemeProvider } from "@/providers/ThemeProvider";
import { TooltipProvider } from "@/components/ui/Tooltip";
import { routeTree } from "./routeTree.gen";

import "./index.css";

const router = createRouter({
  routeTree,
  defaultPreload: "intent",
});

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}

const rootEl = document.getElementById("root");
if (!rootEl) {
  throw new Error("#root not found in index.html");
}

createRoot(rootEl).render(
  <StrictMode>
    <ThemeProvider>
      <DemoModeProvider>
        <QueryProvider>
          <CommandPaletteProvider>
            <TooltipProvider delayDuration={200} skipDelayDuration={300}>
              <RouterProvider router={router} />
            </TooltipProvider>
          </CommandPaletteProvider>
        </QueryProvider>
      </DemoModeProvider>
    </ThemeProvider>
  </StrictMode>,
);
